module.exports = __webpack_public_path__ + "img/3_03.b5de74ae.jpg";